import { createAsyncThunk } from '@reduxjs/toolkit';
import { AxiosError } from 'axios';
import {
  IReEnrollmentCyclesResponse,
  IReEnrollmentCycleResponseById,
  IReEnrollmentCyclesQueryParams,
  IActivateReEnrollmentCycleResponse,
  IFinalizeReEnrollmentCycleResponse,
} from '../../interface/reEnrollment.interface';
import { IErrorResponse } from '../../interface/main.interface';
import { reEnrollmentService } from '../../services/reEnrollment';

// Fetch all re-enrollment cycles with optional query params
export const fetchReEnrollmentCycles = createAsyncThunk<
  IReEnrollmentCyclesResponse,
  IReEnrollmentCyclesQueryParams | undefined,
  { rejectValue: IErrorResponse }
>('reEnrollment/fetch-all', async (params, { rejectWithValue }) => {
  try {
    const response = await reEnrollmentService.fetchReEnrollmentCycles(params);
    return response.data;
  } catch (err) {
    const error = err as AxiosError<IErrorResponse>;
    if (!error.response) {
      throw err;
    }
    return rejectWithValue(error.response.data);
  }
});

// Fetch single re-enrollment cycle by ID
export const fetchReEnrollmentCycle = createAsyncThunk<
  IReEnrollmentCycleResponseById,
  string,
  { rejectValue: IErrorResponse }
>('reEnrollment/fetch-one', async (cycleId, { rejectWithValue }) => {
  try {
    const response = await reEnrollmentService.fetchReEnrollmentCycle(cycleId);
    return response.data;
  } catch (err) {
    const error = err as AxiosError<IErrorResponse>;
    if (!error.response) {
      throw err;
    }
    return rejectWithValue(error.response.data);
  }
});

// Activate re-enrollment cycle
export const activateReEnrollmentCycle = createAsyncThunk<
  IActivateReEnrollmentCycleResponse,
  string,
  { rejectValue: IErrorResponse }
>('reEnrollment/activate-cycle', async (cycleId, { rejectWithValue }) => {
  try {
    const response = await reEnrollmentService.activateReEnrollmentCycle(cycleId);
    return response.data;
  } catch (err) {
    const error = err as AxiosError<IErrorResponse>;
    if (!error.response) {
      throw err;
    }
    return rejectWithValue(error.response.data);
  }
});

// Finalize re-enrollment cycle
export const finalizeReEnrollmentCycle = createAsyncThunk<
  IFinalizeReEnrollmentCycleResponse,
  string,
  { rejectValue: IErrorResponse }
>('reEnrollment/finalize-cycle', async (cycleId, { rejectWithValue }) => {
  try {
    const response = await reEnrollmentService.finalizeReEnrollmentCycle(cycleId);
    return response.data;
  } catch (err) {
    const error = err as AxiosError<IErrorResponse>;
    if (!error.response) {
      throw err;
    }
    return rejectWithValue(error.response.data);
  }
});

export const reEnrollmentActions = {
  fetchReEnrollmentCycles,
  fetchReEnrollmentCycle,
  activateReEnrollmentCycle,
  finalizeReEnrollmentCycle,
};
